import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import { toggleAffiliationRole } from '@/lib/contacts/affiliations'

export const affiliationRoles = ['Employee', 'Primary contact', 'Billing contact', 'Roster manager']

export function AffiliationRoleCheckboxes({
  roles,
  onChange,
  idPrefix,
}: {
  roles: string[]
  onChange: (roles: string[]) => void
  idPrefix: string
}) {
  return (
    <div className="flex flex-col gap-2">
      <span className="text-body-sm text-foreground">Roles</span>
      {affiliationRoles.map((role) => {
        const id = `${idPrefix}-${role.toLowerCase().replace(/\s+/g, '-')}`
        return (
          <div key={role} className="flex items-center gap-2">
            <Checkbox
              id={id}
              checked={roles.includes(role)}
              onCheckedChange={(checked) => onChange(toggleAffiliationRole(roles, role, checked))}
            />
            <Label htmlFor={id} className="text-muted-foreground">
              {role}
            </Label>
          </div>
        )
      })}
    </div>
  )
}
